import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Img = styled.img`
  opacity: 0;
  transition: opacity 400ms;

  ${({ imageLoaded }) =>
    imageLoaded &&
    css`
      opacity: 1;
    `}
`;

const FadeInImage = ({ src, ...props }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    let timeout;
    img.onload = () => {
      timeout = setTimeout(() => setImageLoaded(true), 100);
    };
    return () => {
      img.onload = () => {};
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [src]);

  return <Img src={src} imageLoaded={imageLoaded} {...props} />;
};

FadeInImage.propTypes = {
  src: PropTypes.string.isRequired
};

export default FadeInImage;
